import React, { useEffect, useState } from 'react';
import { Container, Grid, Typography, Box, Stack, Pagination, PaginationItem, useTheme, TextField, FormControlLabel, Checkbox, Rating, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import axios from 'axios';
import Shoot from '../../../../layout/Shoot';
import { CommonHeading, CommonTitle, DesignBtn } from '../../../../layout/Common';
import Swal from 'sweetalert2';

function ShopCard({ onLoaded }) {
  const theme = useTheme();
  const [AllProduct, setAllProduct] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalProductCount, setTotalProductCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 12; // Number of items per page

  const fetchFilteredProducts = async (filters) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_APP}/api/GetAllProduct?page=${currentPage}&limit=${itemsPerPage}`);
      setAllProduct(response.data.data);
      setTotalPages(response.data.totalPages);
      setTotalProductCount(response.data.totalRecords)
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      onLoaded();
    }
  };

  useEffect(() => {
    fetchFilteredProducts({});
  }, []);

  useEffect(() => {
    fetchFilteredProducts();
  }, [currentPage])

  const [name, setName] = useState('');
  const [rating, setRating] = useState(0);
  const [description, setDescription] = useState('');
  const [images, setImages] = useState([]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
  };


  const handleSubmit = async () => {
    if (!name || !rating || !description) {
      alert('Name, Rating, and Description are required!');
      return;
    }

    const formData = new FormData();
    formData.append('name', name);
    formData.append('ReviewStart', rating);
    formData.append('Description', description);

    images.forEach((image) => {
      formData.append('images', image);
    });

    try {
      setLoading(true);
      const response = await axios.post('/api/add-review', formData);
      alert('Review submitted successfully!');
      setName('');
      setRating(0);
      setDescription('');
      setImages([]);
    } catch (error) {
      console.error(error);
      alert('Error submitting review.');
    } finally {
      setLoading(false);
    }
  };




  return (
    <Box sx={{ backgroundColor: theme.palette.background.default, color: '#000', padding: { lg: '50px 100px', xs: '50px 0px' } }}>
      <Container maxWidth="xxl">
        <Box sx={{ backgroundColor: theme.palette.background.brownDark, p: { md: '80px 100px', xs: '50px 40px' } }}>
          <CommonTitle text={'Customer Reviews'} margin={'0px 0px 15px 0px'} />
          <CommonHeading text={"Wriate a Reviews"} fontSize={"39px"} fontWeight={"400"} />
          <Box sx={{ mt: 3 }}>
            <TextField
              label="Your Name*"
              variant="outlined"
              fullWidth
              margin="normal"
              onChange={(e) => setName(e.target.value)}
              InputLabelProps={{ style: { color: '#9a9998' } }}
              InputProps={{ style: { color: '#9a9998', borderColor: '#9a9998', my: 3 } }}
            />
          </Box>

          <Box mt={3}>
            <Typography sx={{ color: '#9a9998', mb: 1 }}>Your Rating*</Typography>
            <Rating
              value={rating}
              onChange={(e, newValue) => setRating(newValue)}
              size="large"
              sx={{ color: '#FFD700' }} // gold stars
            />
          </Box>

          <Box sx={{ my: 3 }}>
            <TextField
              label="Describe your review*"
              variant="outlined"
              fullWidth
              margin="normal"
              multiline
              rows={4}
              onChange={(e) => setDescription(e.target.value)}
              InputLabelProps={{ style: { color: '#9a9998' } }}
              InputProps={{ style: { color: '#9a9998', borderColor: '#9a9998' } }}
            />
          </Box>

          <Box mt={3}>
            <Typography sx={{ color: '#9a9998', mb: 1 }}>Review Img*</Typography>
            <label htmlFor="upload-multiple">
              <input
                accept="image/*"
                id="upload-multiple"
                multiple
                type="file"
                onChange={handleImageChange}
                style={{ display: 'block', marginTop: '10px', color: '#9a9998' }}
              />
            </label>

            <Box mt={1} display="flex" flexWrap="wrap" gap={1}>
              {images.map((img, i) => (
                <img
                  key={i}
                  src={URL.createObjectURL(img)}
                  alt={`review-img-${i}`}
                  style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 4 }}
                />
              ))}
            </Box>
          </Box>

          <Box sx={{ width: { xl: '30%', lg: '50%', md: '30%', sm: '40%' } }} mt={3}>
            <Button onClick={handleSubmit} sx={{
              position: 'relative',
              overflow: 'hidden',
              textTransform: 'uppercase',
              border: '1px solid #BB9D7B',
              borderRadius: '0',
              color: '#fff',
              padding: '10px 30px',
              zIndex: 1,
              width: '100%',
              transition: 'all 0.3s linear 0s',
              fontFamily: theme.palette.typography.fontFamily1,
              color: '#BB9D7B'
              , '&:hover': {
                backgroundColor: theme.palette.primary.gold,
                color: theme.palette.primary.main
              }

            }}
              disabled={loading}>
              {loading ? "Processing..." : "Submit Review"}
            </Button>
            {/* <DesignBtn text={"LET'S GET START"} width={'100%'} onClick={handleSubmit} /> */}
          </Box>

        </Box>
        <Grid container spacing={3}>
          {/* <Grid item xs={12} md={3.5} xl={3}>
              <Sidebar onFilterChange={handleFilterChange} collectionclick={handlecollectionClick}/>
            </Grid> */}
          <Grid item xs={12}>
            <Box sx={{ p: { sm: 3, xs: 1 } }}>
              <Box sx={{ mb: 4, borderBottom: '1px solid #343333', pb: 3, mt: 5 }}>
                <Typography variant="h6" sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px' }}>
                  Showing 1 – {itemsPerPage} of {totalProductCount} results
                </Typography>
              </Box>
              <Grid container>
                {AllProduct.map((val, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <Shoot
                      primaryImg={val?.ProductImage}
                      // primaryImg={`${process.env.REACT_APP_BACKEND_APP}/uploads/` + val?.ProductImage}
                      title={val?.ClothesType}
                      price={val.ProductPrice}
                      ShirtMeter={val?.ShirtMeter}
                      PaintMeter={val?.PaintMeter}
                      FabricType={val?.FabricType} 
                      TrouserMeter={val?.TrouserMeter} 
                      KurtaMeter={val?.KurtaMeter}
                      DiscountPrice={val?.DiscountPrice}
                      slug={val.unqid}
                      imageHeight={"500px"}
                    />
                  </Grid>
                ))}
              </Grid>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
                <Stack spacing={4}>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={(event, value) => setCurrentPage(value)}
                    renderItem={(item) => (
                      <PaginationItem
                        slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                        sx={{ fontFamily: theme.palette.typography.fontFamily1, fontSize: '20px' }}
                      />
                    )}
                  />
                </Stack>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default ShopCard;
